import React from 'react';

import { Navigate, Routes, Route } from 'react-router-dom';

import { useAuth } from '../common/hooks';

import { Login, ResetPassword, ConfirmResetPassword } from './components';

const Auth: React.FC = () => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated()) {
    return <Navigate to="app/accounts" />;
  }

  return (
    <div className="flex min-h-screen bg-gradient-to-r from-primary-0.0 to-primary-3.0">
      <div className="lg:block flex-1 hidden w-0" />
      <div className="lg:flex-none lg:w-1/3 flex flex-col justify-center flex-1 sm:px-6 md:px-8 lg:px-12 px-4 py-12 bg-white-0.0">
        <Routes>
          <Route path="login" element={<Login />} />
          <Route path="reset_password" element={<ResetPassword />} />
          <Route path="reset_password/:token" element={<ConfirmResetPassword />} />
          <Route path="*" element={<Navigate to="login" />} />
        </Routes>
      </div>
    </div>
  );
};

export default Auth;
